import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router-dom";

import { IAsyncData } from "../../../../core/models";
import { Routing } from "../../../../core/routing";
import { IAppReduxState } from "../../../../redux/store";
import { ROUTES } from "../../../../routes";
import { expenseEditFormValidation, IExpense, IExpenseForm } from "../../data/entities";
import { ExpenseForm } from "../components/form";
import { expenseRedux } from "../state/state";

export const ExpenseEditPage: React.FC = () => {
  const match = useRouteMatch<{ id: string }>();
  const id = match.params.id;
  const dispatch = useDispatch();
  const history = useHistory();

  const expenseDetailBranch = useSelector<IAppReduxState, IAsyncData<IExpense>>((state) => state.expense.details);
  const editExpenseBranch = useSelector<IAppReduxState, IAsyncData<void>>((state) => state.expense.edit);

  useEffect(() => {
    dispatch(expenseRedux.actions.getDetail(id));
  }, [dispatch, id]);

  const onSubmit = async (form: IExpenseForm): Promise<void> => {
    await dispatch(expenseRedux.actions.edit(id, form));
    history.push(Routing.generateDetailRoute(ROUTES.expense, id));
  };

  return (
    <ExpenseForm
      initialData={expenseDetailBranch}
      onSubmit={onSubmit}
      branch={editExpenseBranch}
      validationSchema={expenseEditFormValidation}
      submitTitle="Edit"
    />
  );
};
